import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopNews from '../../common/header/HeaderTopNews';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import { FiArrowRight } from 'react-icons/fi';
import SectionTitle from '../../elements/sectionTitle/SectionTitle';
import SpeakingCategories from '../../components/speaking/SpeakingCategories';
import SpeakingSpeaker from '../../components/speaking/SpeakingSpeaker';
import Separator from '../../elements/separator/Separator';
import SpeakingCallToAction from '../../components/speaking/SpeakingCallToAction';
import SpeakerFormTabs from '../../components/speaking/SpeakerFormTabs';

const Speaking = () => {
    
    return (
        <>
            <SEO title="Speaker Booking" />
            <main className="page-wrapper">
                {/* <HeaderTopNews /> */}
                <HeaderOne  btnStyle="btn-small round btn-icon" HeaderSTyle="header-transparent" />




                {/* Start Speaker Info*/}
                <div className="rwt-advance-tab-area rn-section-gap">
                    <div className="container">
                        <div className="row mb--40">
                            <div className="col-lg-12">
                                {/* <SectionTitle
                                    textAlign = "text-center"
                                    radiusRounded = ""
                                    // subtitle = "Consulting Services"
                                    title = "Speaker"
                                    description = ""
                                /> */}
                                <h4 className='text-center'>CONTACT</h4>
                            </div>
                        </div>
                        <SpeakerFormTabs/>
                    </div>
                </div>
                {/* End Speaker Info  */}


                {/* Start Elements Area  */}
                <div className="rwt-callto-action-area rn-section-gapBottom">
                    <div className="wrapper">
                        <SpeakingCallToAction />
                    </div>
                </div>
                {/* End Elements Area  */}



                <FooterOne />
                <Copyright />                    

            </main>
            
        </>
    )
}
export default Speaking

